export const fonts = [
  {
    value: 'Roboto Serif',
    label: 'Roboto Serif',
    url: 'https://fonts.gstatic.com/s/robotoserif/v13/R705jywflP6FLr3gZx7K8UyEVQnyR1E7VN-f51xYuGCQepO9CRLLcmv0wAqC-wwkpEzi.woff2'
  },
  {
    value: 'Cambria',
    label: 'Cambria',
    url: ''
  },
  {
    value: 'Cabin',
    label: 'Cabin',
    url: 'https://fonts.gstatic.com/s/cabin/v27/u-4g0qWljRw-Pd815fNqc8T_wAFcX-c37OnuHXg.woff2'
  },
  {
    value: 'Helvetica',
    label: 'Helvetica',
    url: ''
  },
  {
    value: 'Playfair Display',
    label: 'Playfair Display',
    url: 'https://fonts.gstatic.com/s/playfairdisplay/v37/nuFkD-vYSZviVYUb_rj3ij__anPXDTnogkk7.woff2'
  },
  {
    value: 'Courgette',
    label: 'Courgette',
    url: 'https://fonts.gstatic.com/s/courgette/v17/wEO_EBrAnc9BLjLQAUk1VvoK.woff2'
  },
  {
    value: 'Great Vibes',
    label: 'Great Vibes',
    url: 'https://fonts.gstatic.com/s/greatvibes/v18/RWmMoKWR9v4ksMfaWd_JN9XFiaQ.woff2'
  },
  {
    value: 'Dancing Script',
    label: 'Dancing Script',
    url: 'https://fonts.gstatic.com/s/dancingscript/v25/If2RXTr6YS-zF4S-kcSWSVi_szLgiuE.woff2'
  },
  {
    value: 'Cormorant SC',
    label: 'Cormorant SC',
    url: 'https://fonts.gstatic.com/s/cormorantsc/v19/0yb5GD4kxqXBmOVLG30OGwsuqzAx.woff2'
  },
  {
    value: 'Cinzel',
    label: 'Cinzel',
    url: 'https://fonts.gstatic.com/s/cinzel/v26/8vIU7ww63mVu7gtR-kwKxNvkNOjw-tbnfY3lDQ.woff2'
  },
  {
    value: 'M PLUS 1p',
    label: 'M PLUS 1p',
    url: 'https://fonts.gstatic.com/s/mplus1p/v33/e3tjeuShHdiFyPFzBRrY_zQF.woff2'
  },
  {
    value: 'Scope One',
    label: 'Scope One',
    url: 'https://fonts.gstatic.com/s/scopeone/v15/WBLnrEXKYFlGHrOKmGDFXEXN.woff2'
  },
  {
    value: 'Mea Culpa',
    label: 'Mea Culpa',
    url: 'https://fonts.gstatic.com/s/meaculpa/v8/AMOTz4GcuWbEIuza8jspnccR.woff2'
  },
  {
    value: 'Parisienne',
    label: 'Parisienne',
    url: 'https://fonts.gstatic.com/s/parisienne/v14/E21i_d3kivvAkxhLEVZpQyhwDw.woff2'
  },
  {
    value: 'Poiret One',
    label: 'Poiret One',
    url: 'https://fonts.gstatic.com/s/poiretone/v18/UqyVK80NJXN4zfRgbdfbo55cVw.woff2'
  },
  {
    value: 'Matangi',
    label: 'Matangi',
    url: 'https://fonts.gstatic.com/s/matangi/v5/kmKiZqE2FhDIeX2QvjZNI_5FGeJet7OWCAY3KcA.woff2'
  },
  {
    value: 'Updock',
    label: 'Updock',
    url: 'https://fonts.gstatic.com/s/updock/v7/nuF4D_3dVZ70UI9ii7i2.woff2'
  }
];
